<template>
    <rkm-modal
        smallLarge
        ref="RkmModal"
        title="Registrar medicamento não atendido"
    >
        <rkm-alert show color="warning">
            Informe a quantidade não atendida, para
            registrar na aba de medicamentos não atendidos.
        </rkm-alert>

        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col cols="8">
                    <rkm-form-input
                        :value="descricaoMedicamento"
                        disabled
                        label="Item"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.quantidade"
                        label="Quantidade"
                        type="number"
                        v-model="quantidade"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :disabled="medicoSolicitanteBloqueado"
                        :repository="repositories.usuario"
                        :requestQueryStringParams="{ with_not_regularized: true }"
                        :searchFields="fields.autocomplete.usuario"
                        :validations="validations.medicoSolicitante"
                        label="Médico solicitante"
                        text-field="cidadaoNome"
                        v-model="medicoSolicitante"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="form.motivoMedicamentoNaoAtendido"
                        :validations="validations.motivo"
                        disabled
                        label="Motivo"
                        text-field="nome"
                        v-model="motivoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer>
            <rkm-button @click.stop="handleExit">
                Cancelar
            </rkm-button>
            <rkm-button
                @click.stop="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins
import { repository, object, error, data } from '@/mixins'

//Enums
import motivo from '@/enums/farmacia/motivoMedicamentoNaoAtendido'

export default {
    computed: {
        descricaoMedicamento() {

            if (!this.item || !this.item.material) return ''

            return this.item.material.descricaoCompleta || this.item.material.descricao
        },
        fields() {
            return {
                autocomplete: {
                    usuario: [{ key: "cadastro_cidadao.nome", searchable: true }],
                },
            }
        },
        validations() {
            return {
                quantidade: { required: true, numeric: true, min_value: 1 },
                medicoSolicitante: { required: true },
                motivo: { required: true },
                justificativa: { required: this.motivoId === this.enums.motivo.OUTROS, min: 3, max: 150 },
            }
        },
    },
    created() {

        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }
    },
    data: () => ({
        item: null,
        quantidade: null,
        medicoSolicitante: null,
        medicoSolicitanteBloqueado: false,
        motivoId: null,
        justificativa: null,
        receitaSessaoId: null,
        enums: {
            motivo
        }
    }),
    methods: {
        open(item, quantidade) {

            this.item = item
            this.quantidade = quantidade
            this.medicoSolicitante = this.model.medicoSolicitante && this.model.medicoSolicitante.id
                ? this.clone(this.model.medicoSolicitante)
                : null
            this.medicoSolicitanteBloqueado = !!this.medicoSolicitante
            this.motivoId = this.enums.motivo.FALTA_EM_ESTOQUE
            this.justificativa = null

            this.$refs.RkmModal.show()
        },
        save() {

            if (!this.quantidade || this.quantidade < 1) {

                this.showValidationNotification('Informe a quantidade não atendida.')

                return
            }

            if (!this.medicoSolicitante || !this.medicoSolicitante.id) {

                this.showValidationNotification('Selecione o médico solicitante.')

                return
            }

            if (!this.motivoId) {

                this.showValidationNotification('Selecione o motivo.')

                return
            }

            if (this.motivoId === this.enums.motivo.OUTROS && (!this.justificativa || this.justificativa.length < 3)) {

                this.showValidationNotification('Informe a justificativa.')

                return
            }

            const dataReceitaFormatada = this.getFormatedDate(this.model.dataReceita, 'DD/MM/YYYY')

            const item = {

                id: `${new Date().getTime()}-medicamento-nao-atendido`,
                materialId: this.item.material.id,
                medicamentoNaoPadronizadoId: null,
                quantidade: this.quantidade,
                justificativa: this.justificativa,
                motivoId: this.motivoId,
                motivo: (this.form.motivoMedicamentoNaoAtendido.find(m => m.id === this.motivoId) || {}).nome || null,
                medicamento: {
                    id: this.item.material.id,
                    descricao: this.item.material.descricao || this.item.material.descricaoCompleta
                },
                save: true,
                deleted: false,
                confirmado: false,
            }

            const incluir = () => {

                let receita = this.receitaSessaoId
                    ? this.model.medicamentoNaoAtendido.find(r => !r.deleted && r.id === this.receitaSessaoId)
                    : null

                if (!receita) {

                    receita = {
                        id: `${new Date().getTime()}-receita-medicamento-nao-atendido`,
                        dataRegistro: this.getFormatedDate(new Date(), 'DD/MM/YYYY'),
                        items: [],
                        save: true,
                        deleted: false,
                    }

                    this.model.medicamentoNaoAtendido.push(receita)
                }

                receita.dataReceita = dataReceitaFormatada
                receita.medicoSolicitante = {
                    id: this.medicoSolicitante.id,
                    nome: this.medicoSolicitante.cidadaoNome
                }
                receita.isReceitaSus = this.model.isReceitaSus ?? true
                receita.save = true

                receita.items.push(item)
                this.receitaSessaoId = receita.id
                this.model.paciente.save = true

                this.$refs.RkmModal.hide()

                this.$emit('save')
            }

            const receitaSessao = this.receitaSessaoId
                ? this.model.medicamentoNaoAtendido.find(r => !r.deleted && r.id === this.receitaSessaoId)
                : null

            const isDuplicado = !!receitaSessao
                && receitaSessao.items.some(i => !i.deleted && i.materialId === item.materialId)

            if (isDuplicado) {

                item.confirmado = true

                this.showConfirmation(
                    `Já existe um registro deste medicamento não atendido para esta receita.
                    Deseja incluir mesmo assim?`,
                    async () => incluir()
                )

                return
            }

            incluir()
        },
        handleExit() {

            this.$refs.RkmModal.hide()

            this.$emit('cancel')
        },
    },
    mixins: [repository, object, error, data],
    props: {
        form: { type: Object, default: null },
        model: { type: Object, default: null }
    },
}
</script>
